import { useMutation } from 'react-query';
import { ForecastParameters } from '../../contexts/investment-robot/ForecastContext';
import { buildEndpoint } from '../endpoints';
import { apifetch, PeriodicInterval, yearsFromNowToDate } from '../robotapi';

export interface GetOnboardingLinkRequest {
    paymentSingleAmount: number;
    paymentRecurringAmount: number;
    paymentRecurringInterval: string;
    fundModelTypeId: number;
    investmentEndDate: string;
    riskReduction: boolean;
}

export type GetOnboardingLinkResponse = string;

const getOnboardingLinkUrl = buildEndpoint(['products', 'investmentfree', 'links']);

const getOnboardingLinkApiCall = (body: GetOnboardingLinkRequest) =>
    apifetch<GetOnboardingLinkResponse, GetOnboardingLinkRequest>(getOnboardingLinkUrl, 'POST')(body);

export const useGetOnboardingLink = (params: ForecastParameters) => {
    const query = useMutation<GetOnboardingLinkResponse>(['onboardlinglink', params], async () => {
        return getOnboardingLinkApiCall(toRequest(params));
    });

    return query;
};

const toRequest = (params: ForecastParameters): GetOnboardingLinkRequest => {
    return {
        fundModelTypeId: Number.parseInt(params.risk.profile.id) || 8,
        paymentSingleAmount: params.deposits.initial.amount / 100, // From cents to euros
        paymentRecurringAmount: params.deposits.periodic.amount / 100, // From cents to euros
        paymentRecurringInterval: toRequestInterval(params.deposits.periodic.interval),
        investmentEndDate: yearsFromNowToDate(params.capitalGoal.inYears),
        riskReduction: params.risk.reduction.isEnabled,
    };
};

const toRequestInterval = (
    periodicInterval: PeriodicInterval,
): GetOnboardingLinkRequest['paymentRecurringInterval'] => {
    switch (periodicInterval) {
        case 'monthly':
            return 'Month';

        case 'yearly':
            return 'Year';

        default:
            return 'None';
    }
};
